"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UIBuilder = void 0;
var react_1 = require("react");
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var tooltip_1 = __importDefault(require("antd/es/tooltip"));
var moment_1 = __importDefault(require("moment"));
var react_2 = __importStar(require("react"));
var react_draggable_1 = __importDefault(require("react-draggable"));
var react_redux_1 = require("react-redux");
var react_to_print_1 = require("react-to-print");
var react_toastify_1 = require("react-toastify");
var ACAccordion_1 = require("../Components/ACAccordion");
var ACAddMoreTable_1 = __importDefault(require("../Components/ACAddMoreTable"));
var ACAlert_1 = require("../Components/ACAlert");
var ACAutoCompleteInput_1 = require("../Components/ACAutoCompleteInput");
var ACAutoCompleteInputWithButton_1 = require("../Components/ACAutoCompleteInputWithButton");
var ACAvatar_1 = require("../Components/ACAvatar");
var ACButton_1 = require("../Components/ACButton");
var ACCard_1 = require("../Components/ACCard");
var ACChart_1 = require("../Components/ACChart");
var ACCheckboxGroup_1 = require("../Components/ACCheckboxGroup");
var ACChip_1 = require("../Components/ACChip");
var ACChipGroup_1 = require("../Components/ACChipGroup");
var ACCircularInput_1 = require("../Components/ACCircularInput");
var ACCollection_1 = require("../Components/ACCollection");
var ACCounter_1 = require("../Components/ACCounter");
var ACDatePicker_1 = require("../Components/ACDatePicker");
var ACDateRangeSegments_1 = require("../Components/ACDateRangeSegments");
var ACDateTimeDisplay_1 = require("../Components/ACDateTimeDisplay");
var ACDivContainer_1 = require("../Components/ACDivContainer");
var ACEmpty_1 = require("../Components/ACEmpty");
var ACFileUpload_1 = require("../Components/ACFileUpload");
var ACFileGallery_1 = require("../Components/ACFileGallery");
var ACLink_1 = __importDefault(require("../Components/ACLink"));
var ACFixedRowInputTable_1 = require("../Components/ACFixedRowInputTable");
var ACGradientCardGroup_1 = require("../Components/ACGradientCardGroup");
var ACIcon_1 = require("../Components/ACIcon");
var ACImage_1 = require("../Components/ACImage");
var ACInputNumber_1 = require("../Components/ACInputNumber");
var ACInputText_1 = require("../Components/ACInputText");
var ACList_1 = __importDefault(require("../Components/ACList"));
var ACNestedSelectableCollection_1 = require("../Components/ACNestedSelectableCollection");
var ACNotifications_1 = require("../Components/ACNotifications");
var ACOtpElement_1 = require("../Components/ACOtpElement");
var ACPagination_1 = require("../Components/ACPagination");
var ACPhoneMasker_1 = require("../Components/ACPhoneMasker");
var ACPrint_1 = require("../Components/ACPrint");
var ACProfileMenu_1 = require("../Components/ACProfileMenu");
var ACProgress_1 = require("../Components/ACProgress");
var ACProgressGroup_1 = require("../Components/ACProgressGroup");
var ACQRComponent_1 = require("../Components/ACQRComponent");
var ACRadioGroup_1 = require("../Components/ACRadioGroup");
var ACSegmentedElement_1 = require("../Components/ACSegmentedElement");
var ACSelectableCollection_1 = require("../Components/ACSelectableCollection");
var ACSelectElement_1 = require("../Components/ACSelectElement");
var ACSkeleton_1 = require("../Components/ACSkeleton");
var ACSkeletonGroup_1 = require("../Components/ACSkeletonGroup");
var ACTableElement_1 = require("../Components/ACTableElement");
var ACTabsControlled_1 = require("../Components/ACTabsControlled");
var ACTextarea_1 = require("../Components/ACTextarea");
var ACTextEditor_1 = require("../Components/ACTextEditor");
var ACTimeline_1 = require("../Components/ACTimeline");
var ACTypography_1 = require("../Components/ACTypography");
var ACWrapperContext_1 = require("../Components/ACWrapperContext");
var LoadingState_1 = __importDefault(require("../Components/LoadingState"));
var RefProvider_1 = require("../context/RefProvider");
var globalHandlers_1 = __importDefault(require("../handlers/globalHandlers"));
var useRippleEffect_1 = require("../hooks/useRippleEffect");
var sampleSlice_1 = require("../redux/slice/sampleSlice");
var utils_1 = require("../utils");
var helpers_1 = require("../utils/helpers");
var restructureSchema_1 = require("../utils/restructureSchema");
var UIBuilderChild = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    (0, useRippleEffect_1.useRippleEffect)();
    var _s = (0, react_2.useState)(new Map()), fieldMap = _s[0], setFieldMap = _s[1];
    var _t = (0, react_2.useState)(((_a = props === null || props === void 0 ? void 0 : props.json) === null || _a === void 0 ? void 0 : _a.schema) || []), schema = _t[0], setSchema = _t[1];
    var _u = (0, react_2.useState)(''), fileName = _u[0], setFileName = _u[1];
    var dispatch = (0, react_redux_1.useDispatch)();
    var contentRef = (0, react_2.useContext)(RefProvider_1.RefContext);
    var reactPrintFn = (0, react_to_print_1.useReactToPrint)({ contentRef: contentRef });
    var store = (0, ACWrapperContext_1.getStore)();
    var state = store === null || store === void 0 ? void 0 : store.getState();
    var navigate = props === null || props === void 0 ? void 0 : props.navigate;
    var rootState = ((_d = (_c = (_b = props === null || props === void 0 ? void 0 : props.json) === null || _b === void 0 ? void 0 : _b.schema) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.name) || '';
    var dynamicState = (0, react_redux_1.useSelector)(function (state) { return state.dynamic; });
    var context = {
        dispatch: dispatch,
        schema: schema,
        setSchema: setSchema,
        navigate: navigate,
        state: state,
        setStateValue: sampleSlice_1.setStateValue,
        rootState: rootState,
    };
    (0, react_2.useEffect)(function () {
        // console.log('Dynamic State Updated:', fileName);
        if (fileName) {
            // reactPrintFn();
        }
    }, [fileName]);
    (0, react_2.useEffect)(function () {
        var _a, _b, _c, _d, _e, _f, _g;
        if ((_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.json) === null || _a === void 0 ? void 0 : _a.schema) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.initial_states) {
            var rootState_1 = ((_e = (_d = props === null || props === void 0 ? void 0 : props.json) === null || _d === void 0 ? void 0 : _d.schema[0]) === null || _e === void 0 ? void 0 : _e.name) || '';
            var initialStates = (_g = (_f = props === null || props === void 0 ? void 0 : props.json) === null || _f === void 0 ? void 0 : _f.schema) === null || _g === void 0 ? void 0 : _g[0].initial_states;
            Object.entries(initialStates).forEach(function (_a) {
                var _b, _c;
                var key = _a[0], value = _a[1];
                if (typeof ((_c = (_b = context === null || context === void 0 ? void 0 : context.state) === null || _b === void 0 ? void 0 : _b.dynamic[rootState_1]) === null || _c === void 0 ? void 0 : _c[key]) !== 'undefined') {
                    return;
                }
                // Handle states with handler functions
                if (typeof value === 'object' && (value === null || value === void 0 ? void 0 : value.action)) {
                    var handler = globalHandlers_1.default[value.action];
                    if (handler) {
                        var result = handler(value.args, context);
                        dispatch((0, sampleSlice_1.setStateValue)({
                            path: "".concat(rootState_1, ".").concat(key),
                            value: result,
                        }));
                    }
                }
                else {
                    // Handle direct value assignment
                    dispatch((0, sampleSlice_1.setStateValue)({
                        path: "".concat(rootState_1, ".").concat(key),
                        value: value,
                    }));
                }
            });
        }
    }, [(_g = (_f = (_e = props === null || props === void 0 ? void 0 : props.json) === null || _e === void 0 ? void 0 : _e.schema) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.initial_states]);
    // Initialize field map when schema changes
    (0, react_2.useEffect)(function () {
        var _a, _b;
        if ((_a = props === null || props === void 0 ? void 0 : props.json) === null || _a === void 0 ? void 0 : _a.schema) {
            setFieldMap(function (prev) {
                var _a;
                var newFieldMap = new Map(prev);
                var mapFields = function (fields) {
                    fields.forEach(function (field) {
                        var name = (field === null || field === void 0 ? void 0 : field.name) || (field === null || field === void 0 ? void 0 : field.key);
                        var subFields = (field === null || field === void 0 ? void 0 : field.fields) || (field === null || field === void 0 ? void 0 : field.items);
                        if (name) {
                            newFieldMap.set(name, field);
                        }
                        if (subFields === null || subFields === void 0 ? void 0 : subFields.length) {
                            mapFields(subFields);
                        }
                    });
                };
                mapFields((_a = props === null || props === void 0 ? void 0 : props.json) === null || _a === void 0 ? void 0 : _a.schema);
                return newFieldMap;
            });
            setSchema((_b = props === null || props === void 0 ? void 0 : props.json) === null || _b === void 0 ? void 0 : _b.schema);
        }
    }, [(_h = props === null || props === void 0 ? void 0 : props.json) === null || _h === void 0 ? void 0 : _h.schema]);
    var reset = ((_j = props === null || props === void 0 ? void 0 : props.json) === null || _j === void 0 ? void 0 : _j.shouldPersistState) === false;
    // console.log("reset value", reset, props?.json?.shouldPersistState);
    (0, react_2.useEffect)(function () {
        return function () {
            if (reset) {
                // console.log("unmount Resetting root state to empty object");
                dispatch((0, sampleSlice_1.resetState)({ page: rootState }));
            }
        };
    }, [reset]);
    // Track debounced effect handlers by their unique keys
    var debouncedEffectHandlers = (0, react_2.useRef)({});
    (((_m = (_l = (_k = props === null || props === void 0 ? void 0 : props.json) === null || _k === void 0 ? void 0 : _k.schema) === null || _l === void 0 ? void 0 : _l[0]) === null || _m === void 0 ? void 0 : _m.fields) || [])
        .filter(function (element) { return element.name === 'effects'; })
        .forEach(function (element) {
        var _a;
        (_a = element === null || element === void 0 ? void 0 : element.handlers) === null || _a === void 0 ? void 0 : _a.forEach(function (handler) {
            var _a, _b;
            var effectHandler = globalHandlers_1.default[handler.action];
            var debounceTime = ((_a = handler === null || handler === void 0 ? void 0 : handler.args) === null || _a === void 0 ? void 0 : _a.debounce) || 0;
            // Resolve nested dependencies
            var getDependencyValue = function (state, rootState, dep) {
                var _a;
                var path = dep.split('.');
                var value = (_a = context === null || context === void 0 ? void 0 : context.state) === null || _a === void 0 ? void 0 : _a.dynamic[rootState];
                for (var _i = 0, path_1 = path; _i < path_1.length; _i++) {
                    var part = path_1[_i];
                    if (value === undefined || value === null) {
                        return undefined;
                    }
                    value = value[part];
                }
                return value;
            };
            var dependencies = (handler.dependencies || []).map(function (dep) {
                return getDependencyValue(state, rootState || '', dep);
            });
            // Create a unique key for this handler based on action and dependencies
            var handlerKey = "".concat(handler.action, "_").concat(((_b = handler.dependencies) === null || _b === void 0 ? void 0 : _b.join('_')) || '', "_").concat(JSON.stringify(handler.args || {}));
            react_2.default.useEffect(function () {
                if (effectHandler &&
                    dependencies.every(function (dep) { return dep !== undefined; })) {
                    var args_1 = __assign(__assign({}, handler === null || handler === void 0 ? void 0 : handler.args), { rootState: rootState });
                    // If debounce time is specified, create or use existing debounced handler
                    if (debounceTime > 0) {
                        if (!debouncedEffectHandlers.current[handlerKey]) {
                            debouncedEffectHandlers.current[handlerKey] = utils_1.Utils.debounce(function () { return effectHandler(args_1, context); }, debounceTime);
                        }
                        // Execute the debounced handler
                        debouncedEffectHandlers.current[handlerKey]();
                        // console.log(
                        //   `Effect handler ${handler.action} debounced for ${debounceTime}ms`,
                        // );
                    }
                    else {
                        // No debounce, execute immediately
                        effectHandler(args_1, context);
                    }
                }
            }, dependencies);
        });
    });
    var onHandleSelect = function (name, value) {
        var _a, _b, _c;
        var field = fieldMap.get(name);
        if (field) {
            field.value = value;
            (_a = props.selectedRecord) === null || _a === void 0 ? void 0 : _a.call(props, field);
            var newSchema = __spreadArray([], schema, true);
            setSchema(newSchema);
            (_b = props.setJSON) === null || _b === void 0 ? void 0 : _b.call(props, __assign(__assign({}, props === null || props === void 0 ? void 0 : props.json), { schema: newSchema }));
        }
        if (typeof value === 'object' &&
            value &&
            'name' in value &&
            value.name === 'pagination') {
            // console.log('returning without calling handlers in handleSelect');
            // console.log("testing")
            // For pagination events, we don't want to run the navigation or other row click handlers
            return;
        }
        var handlers = ((_c = field === null || field === void 0 ? void 0 : field.handlers) === null || _c === void 0 ? void 0 : _c.filter(function (item) {
            return item.type == 'onSelect';
        })) || [];
        handlers.forEach(function (handler) {
            var _a, _b;
            var handlerFn = globalHandlers_1.default[handler.action];
            if (handlerFn) {
                var val = ((_a = handler === null || handler === void 0 ? void 0 : handler.args) === null || _a === void 0 ? void 0 : _a.defaultValue) !== undefined
                    ? (_b = handler === null || handler === void 0 ? void 0 : handler.args) === null || _b === void 0 ? void 0 : _b.defaultValue
                    : value;
                // value = handler?.args?.value ? handler?.args?.value : value;
                handler.args = __assign(__assign({}, handler.args), { rootState: rootState, value: val, event: field });
                // console.log(`calling handler select ${handler.action}`, handler.args);
                handlerFn(handler.args, context);
            }
        });
    };
    var onHandleChange = function (name, value, node) {
        var _a, _b, _c, _d, _e, _f;
        // console.log('__value event onHandleChange1', name, value);
        var field = (_a = fieldMap.get(name)) !== null && _a !== void 0 ? _a : node;
        if (field) {
            if (value) {
                field.value = value;
            }
            (_b = props.selectedRecord) === null || _b === void 0 ? void 0 : _b.call(props, field);
            var newSchema = __spreadArray([], schema, true);
            setSchema(newSchema);
            (_c = props.setJSON) === null || _c === void 0 ? void 0 : _c.call(props, __assign(__assign({}, props === null || props === void 0 ? void 0 : props.json), { schema: newSchema }));
        }
        if (typeof value === 'object' &&
            value &&
            'name' in value &&
            value.name === 'pagination') {
            // console.log('returning calling pagination handlers', name, value);
            var paginationHandlers = ((_d = field === null || field === void 0 ? void 0 : field.handlers) === null || _d === void 0 ? void 0 : _d.filter(function (item) {
                return item.type === 'pagination_handler';
            })) || [];
            paginationHandlers.forEach(function (handler) {
                var handlerFn = globalHandlers_1.default[handler.action];
                if (handlerFn) {
                    handler.args = __assign(__assign({}, handler.args), { rootState: rootState, value: value, event: field });
                    handlerFn(handler.args, context);
                }
            });
            context.dispatch(context.setStateValue({
                path: "".concat(rootState, ".").concat(name, ".pagination"),
                value: value,
            }));
            // For pagination events, we don't want to run the navigation or other row click handlers
            return;
        }
        if (typeof value === 'object' &&
            value &&
            'name' in value &&
            value.name === 'filters') {
            var handlers_1 = ((_e = field === null || field === void 0 ? void 0 : field.handlers) === null || _e === void 0 ? void 0 : _e.filter(function (item) {
                return item.type === 'filters_handler';
            })) || [];
            handlers_1.forEach(function (handler) {
                var handlerFn = globalHandlers_1.default[handler.action];
                if (handlerFn) {
                    handler.args = __assign(__assign({}, handler.args), { rootState: rootState, value: value, event: field });
                    handlerFn(handler.args, context);
                }
            });
            context.dispatch(context.setStateValue({
                path: "".concat(rootState, ".").concat(name, ".filters"),
                value: value,
            }));
            return;
        }
        var handlers = ((_f = field === null || field === void 0 ? void 0 : field.handlers) === null || _f === void 0 ? void 0 : _f.filter(function (item) {
            return (item.type == 'onChange' || item.type == '' || item.type == undefined);
        })) || [];
        handlers.forEach(function (handler) {
            var _a, _b;
            var handlerFn = globalHandlers_1.default[handler.action];
            if (handlerFn) {
                // console.log('__value event onHandleChange4', name, value, handler);
                var val = ((_a = handler === null || handler === void 0 ? void 0 : handler.args) === null || _a === void 0 ? void 0 : _a.defaultValue) !== undefined
                    ? (_b = handler === null || handler === void 0 ? void 0 : handler.args) === null || _b === void 0 ? void 0 : _b.defaultValue
                    : value;
                // console.log('__value event onHandleChange5', val, handler);
                handler.args = __assign(__assign({}, handler.args), { rootState: rootState, value: val, event: field });
                // console.log(`calling handler ${handler.action}`, handler.args);
                handlerFn(handler.args, context);
            }
        });
    };
    //     const newSchema = [...schema];
    //     setSchema(newSchema);
    //     props.setData?.({ ...props.json, schema: newSchema });
    //   }
    //   if (
    //     typeof value === 'object' &&
    //     value &&
    //     'name' in value &&
    //     value.name === 'pagination'
    //   ) {
    //     console.log('returning without calling handlers');
    //     // For pagination events, we don't want to run the navigation or other row click handlers
    //     return;
    //   }
    //   const handlers = field?.handlers || [];
    //   handlers.forEach((handler: any) => {
    //     if (handler.type && handler.type === 'onSelect') return;
    //     const handlerFn = globalHandlers[handler.action];
    //     if (handlerFn) {
    //       handler.args = { ...handler.args, rootState, value, event: field };
    //       handlerFn(handler.args, context);
    //     }
    //   });
    // };
    var renderElement = function (elementProps, event, pageName) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27;
        if ((elementProps === null || elementProps === void 0 ? void 0 : elementProps.label) &&
            typeof (elementProps === null || elementProps === void 0 ? void 0 : elementProps.label) === 'object' &&
            'template' in elementProps.label) {
            elementProps = __assign(__assign({}, elementProps), { label: helpers_1.Helper.getProcessedLabel(elementProps, context) });
        }
        if ((elementProps === null || elementProps === void 0 ? void 0 : elementProps.disabled) && typeof elementProps.disabled === 'object') {
            elementProps = __assign(__assign({}, elementProps), { disabled: helpers_1.Helper.getNestedValue((_a = state.dynamic) === null || _a === void 0 ? void 0 : _a[rootState || ''], elementProps.disabled.storedLocation) });
        }
        if (elementProps.disabledCondition) {
            elementProps = __assign(__assign({}, elementProps), { disabled: globalHandlers_1.default.execFunction({ condition: elementProps.disabledCondition, event: event }, context) });
        }
        var executeEventHandlers = function (handlers, event, value) { return __awaiter(void 0, void 0, void 0, function () {
            var _i, handlers_2, handler, handlerFn, result, error_1;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!Array.isArray(handlers) || handlers.length === 0)
                            return [2 /*return*/];
                        _i = 0, handlers_2 = handlers;
                        _d.label = 1;
                    case 1:
                        if (!(_i < handlers_2.length)) return [3 /*break*/, 7];
                        handler = handlers_2[_i];
                        _d.label = 2;
                    case 2:
                        _d.trys.push([2, 5, , 6]);
                        handlerFn = globalHandlers_1.default[handler.action];
                        if (!handlerFn) return [3 /*break*/, 4];
                        value =
                            'value' in handler
                                ? handler.value
                                : 'args' in handler && 'value' in handler.args
                                    ? handler.args.value
                                    : value;
                        // console.log(
                        //   '__redux executing handler',
                        //   handler,
                        //   event,
                        //   value,
                        //   handler.args.value,
                        // );
                        // if (typeof value === 'boolean') {
                        //   value = value ? 1 : 0;
                        // }
                        handler.args = __assign(__assign({}, handler.args), { rootState: rootState, event: event, value: value });
                        if ((handler === null || handler === void 0 ? void 0 : handler.action) === 'validateForm') {
                            handler.args = __assign(__assign({}, handler.args), { schema: ((_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.json) === null || _a === void 0 ? void 0 : _a.schema) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.fields) || [] });
                        }
                        return [4 /*yield*/, handlerFn(handler.args, context)];
                    case 3:
                        result = _d.sent();
                        _d.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        error_1 = _d.sent();
                        console.error("Error executing handler ".concat(handler.action, ":"), error_1);
                        return [3 /*break*/, 6];
                    case 6:
                        _i++;
                        return [3 /*break*/, 1];
                    case 7: return [2 /*return*/];
                }
            });
        }); };
        var getLabelFromRedux = function (_a) {
            var _b, _c, _d, _e;
            var _f = _a === void 0 ? {} : _a, transformer = _f.transformer;
            var state = (_c = (_b = context === null || context === void 0 ? void 0 : context.state) === null || _b === void 0 ? void 0 : _b.dynamic) === null || _c === void 0 ? void 0 : _c[rootState || ''];
            var _g = elementProps || {}, labelSource = _g.labelSource, name = _g.name, label = _g.label;
            if (typeof (labelSource === null || labelSource === void 0 ? void 0 : labelSource.storedLocation) === 'string' &&
                ((_d = labelSource === null || labelSource === void 0 ? void 0 : labelSource.storedLocation) === null || _d === void 0 ? void 0 : _d.includes('@item'))) {
                var path = (_e = labelSource === null || labelSource === void 0 ? void 0 : labelSource.storedLocation) === null || _e === void 0 ? void 0 : _e.replace('@item.', '');
                var nestedValue_1 = helpers_1.Helper.getNestedValue(event, path);
                return nestedValue_1 || (labelSource === null || labelSource === void 0 ? void 0 : labelSource.default) || '';
            }
            var nestedValue = helpers_1.Helper.getNestedValue(state, labelSource === null || labelSource === void 0 ? void 0 : labelSource.storedLocation);
            var defaultLabel = (labelSource === null || labelSource === void 0 ? void 0 : labelSource.default) || '';
            nestedValue = helpers_1.Helper.getTransformedLabel({
                transformer: transformer,
                value: nestedValue,
                defaultLabel: defaultLabel,
            });
            return nestedValue || (state === null || state === void 0 ? void 0 : state[name]) || label || defaultLabel;
        };
        var getOptionsFromRedux = function () {
            var _a, _b;
            var state = (_b = (_a = context === null || context === void 0 ? void 0 : context.state) === null || _a === void 0 ? void 0 : _a.dynamic) === null || _b === void 0 ? void 0 : _b[rootState || ''];
            var _c = elementProps || {}, optionsSource = _c.optionsSource, name = _c.name, options = _c.options;
            return (helpers_1.Helper.getNestedValue(state, optionsSource === null || optionsSource === void 0 ? void 0 : optionsSource.storedLocation) ||
                options ||
                []);
        };
        var getDataFromRedux = function () {
            var _a, _b;
            var state = (_b = (_a = context === null || context === void 0 ? void 0 : context.state) === null || _a === void 0 ? void 0 : _a.dynamic) === null || _b === void 0 ? void 0 : _b[rootState || ''];
            var _c = elementProps || {}, dataSource = _c.dataSource, name = _c.name, data = _c.data;
            return (helpers_1.Helper.getNestedValue(state, dataSource === null || dataSource === void 0 ? void 0 : dataSource.storedLocation) ||
                (state === null || state === void 0 ? void 0 : state[name]) ||
                data ||
                []);
        };
        var getAvatarTextFromRedux = function () {
            var _a, _b;
            var state = (_b = (_a = context === null || context === void 0 ? void 0 : context.state) === null || _a === void 0 ? void 0 : _a.dynamic) === null || _b === void 0 ? void 0 : _b[rootState || ''];
            var _c = elementProps || {}, avatarTextSource = _c.avatarTextSource, name = _c.name, avatarText = _c.avatarText;
            return (helpers_1.Helper.getNestedValue(state, avatarTextSource === null || avatarTextSource === void 0 ? void 0 : avatarTextSource.storedLocation) ||
                (state === null || state === void 0 ? void 0 : state[name]) ||
                avatarText ||
                '');
        };
        var getItemsFromRedux = function (keyName) {
            var _a, _b, _c, _d;
            if (keyName === void 0) { keyName = 'items'; }
            var state = (_b = (_a = context === null || context === void 0 ? void 0 : context.state) === null || _a === void 0 ? void 0 : _a.dynamic) === null || _b === void 0 ? void 0 : _b[rootState || ''];
            var name = (elementProps || {}).name;
            var source = "".concat(keyName, "Source");
            var itemsSource = elementProps[source];
            var items = elementProps[keyName];
            if (typeof (itemsSource === null || itemsSource === void 0 ? void 0 : itemsSource.storedLocation) === 'string' &&
                ((_c = itemsSource === null || itemsSource === void 0 ? void 0 : itemsSource.storedLocation) === null || _c === void 0 ? void 0 : _c.includes('@item'))) {
                var path = (_d = itemsSource === null || itemsSource === void 0 ? void 0 : itemsSource.storedLocation) === null || _d === void 0 ? void 0 : _d.replace('@item.', '');
                var nestedValue = helpers_1.Helper.getNestedValue(event, path);
                return nestedValue || (itemsSource === null || itemsSource === void 0 ? void 0 : itemsSource.default) || '';
            }
            return (helpers_1.Helper.getNestedValue(state, itemsSource === null || itemsSource === void 0 ? void 0 : itemsSource.storedLocation) ||
                (state === null || state === void 0 ? void 0 : state[name]) ||
                items ||
                []);
        };
        var getValueFromRedux = function () {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            // console.log('__value event getValueFromRedux', elementProps);
            return typeof elementProps.valueSource === 'object'
                ? helpers_1.Helper.getNestedValue((_b = (_a = context === null || context === void 0 ? void 0 : context.state) === null || _a === void 0 ? void 0 : _a.dynamic) === null || _b === void 0 ? void 0 : _b[rootState || ''], (_c = elementProps === null || elementProps === void 0 ? void 0 : elementProps.valueSource) === null || _c === void 0 ? void 0 : _c.storedLocation)
                : ((_h = (_g = (_f = (_e = (_d = context === null || context === void 0 ? void 0 : context.state) === null || _d === void 0 ? void 0 : _d.dynamic) === null || _e === void 0 ? void 0 : _e[rootState || '']) === null || _f === void 0 ? void 0 : _f[elementProps === null || elementProps === void 0 ? void 0 : elementProps.name]) !== null && _g !== void 0 ? _g : elementProps === null || elementProps === void 0 ? void 0 : elementProps.value) !== null && _h !== void 0 ? _h : '');
        };
        // Alphabetically sorted components
        switch (elementProps === null || elementProps === void 0 ? void 0 : elementProps.element) {
            // Add this import at the top with other component imports
            case 'accordion': {
                var node = elementProps;
                return ((0, jsx_runtime_1.jsx)(ACAccordion_1.ACAccordion, __assign({}, node, { value: getValueFromRedux(), items: getItemsFromRedux(), renderFields: renderFields })));
            }
            case 'alert': {
                var node = elementProps;
                return (0, jsx_runtime_1.jsx)(ACAlert_1.ACAlert, __assign({}, node));
            }
            case 'array-display': {
                return ((0, jsx_runtime_1.jsx)(ACList_1.default, { items: typeof elementProps.itemsSource === 'object'
                        ? helpers_1.Helper.getNestedValue((_c = (_b = context === null || context === void 0 ? void 0 : context.state) === null || _b === void 0 ? void 0 : _b.dynamic) === null || _c === void 0 ? void 0 : _c[rootState || ''], elementProps.itemsSource.storedLocation)
                        : elementProps.items || [], className: elementProps.containerClassName || 'flex flex-wrap gap-2', itemClassName: elementProps.itemClassName, selectedItemClassName: elementProps.selectedItemClassName, displayKey: elementProps.displayKey, displayFormat: elementProps.displayFormat, compareKey: elementProps.compareKey, value: getValueFromRedux(), onChange: function (value) {
                        return onHandleChange(elementProps.name || '', value, elementProps);
                    }, multiSelect: elementProps.multiSelect, showSelectAll: elementProps.showSelectAll, selectAllText: elementProps.selectAllText || 'Select All' }));
            }
            case 'auto-complete': {
                var node_1 = elementProps;
                return ((0, jsx_runtime_1.jsx)(ACAutoCompleteInput_1.ACAutoCompleteInput, __assign({}, node_1, { items: elementProps.options
                        ? elementProps.options
                        : ((_f = (_e = (_d = state.dynamic) === null || _d === void 0 ? void 0 : _d[rootState || '']) === null || _e === void 0 ? void 0 : _e[node_1.name]) === null || _f === void 0 ? void 0 : _f.data) || [], value: getValueFromRedux() || '', onChange: function (value) { return onHandleChange(node_1.name || '', value, node_1); }, onSelect: function (value) { return onHandleSelect(node_1.name || '', value); }, context: context, rootState: rootState })));
            }
            case 'auto-complete-button':
                return ((0, jsx_runtime_1.jsx)(ACAutoCompleteInputWithButton_1.ACAutoCompleteInputWithButton, __assign({}, elementProps, { items: ((_k = (_j = (_h = (_g = context === null || context === void 0 ? void 0 : context.state) === null || _g === void 0 ? void 0 : _g.dynamic) === null || _h === void 0 ? void 0 : _h[rootState || '']) === null || _j === void 0 ? void 0 : _j[elementProps.name]) === null || _k === void 0 ? void 0 : _k.data) || [], onChange: function (value) {
                        return onHandleChange(elementProps.name || '', value, elementProps);
                    }, onSelect: function (value) {
                        return onHandleSelect(elementProps.name || '', value);
                    }, context: context })));
            case 'avatar': {
                var node = elementProps;
                return (0, jsx_runtime_1.jsx)(ACAvatar_1.ACAvatar, __assign({}, node));
            }
            case 'avatar-name': {
                var name_1 = elementProps.label || '';
                return name_1 && name_1 !== 'Unknown' ? ((0, jsx_runtime_1.jsxs)("div", { className: "flex gap-1 items-center", children: [(0, jsx_runtime_1.jsx)(antd_1.Avatar, { size: elementProps.size || 'small', style: {
                                backgroundColor: "".concat(helpers_1.Helper.stringToColour(name_1)),
                            }, children: (0, jsx_runtime_1.jsx)("p", { className: "capitalize", children: helpers_1.Helper.initials(name_1) }) }), (0, jsx_runtime_1.jsx)("span", { className: "capitalize", children: name_1 })] })) : ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(antd_1.Avatar, { size: 'small' }), (0, jsx_runtime_1.jsx)("span", { children: name_1 })] }));
            }
            case 'add-more-table':
                var tableHeaders = elementProps.thead || [];
                if ((_l = elementProps === null || elementProps === void 0 ? void 0 : elementProps.theadSource) === null || _l === void 0 ? void 0 : _l.storedLocation) {
                    var theadData = helpers_1.Helper.getNestedValue((_m = state.dynamic) === null || _m === void 0 ? void 0 : _m[rootState || ''], elementProps.theadSource.storedLocation);
                    if (theadData && Array.isArray(theadData)) {
                        tableHeaders = theadData.map(function (item) { return (__assign(__assign({}, item), { width: (item === null || item === void 0 ? void 0 : item.width) || '150px' })); });
                    }
                }
                return ((0, jsx_runtime_1.jsx)(ACAddMoreTable_1.default, __assign({}, elementProps, { onChange: function (value) {
                        return onHandleChange(elementProps.name || '', value, elementProps);
                    }, disabled: elementProps.disabled ||
                        ((_r = (_q = (_p = (_o = context === null || context === void 0 ? void 0 : context.state) === null || _o === void 0 ? void 0 : _o.dynamic) === null || _p === void 0 ? void 0 : _p[rootState || '']) === null || _q === void 0 ? void 0 : _q[elementProps.name]) === null || _r === void 0 ? void 0 : _r.disabled), thead: tableHeaders, rootState: rootState, context: context })));
            case 'button':
                return ((0, jsx_runtime_1.jsx)(ACButton_1.ACButton, __assign({}, elementProps, { onClick: function () {
                        var _a;
                        if (elementProps.allowPrint) {
                            var tempFileName = 'document'; // Default value
                            if (typeof elementProps.fileName === 'string') {
                                tempFileName = elementProps.fileName;
                            }
                            else if (typeof elementProps.fileName === 'object') {
                                tempFileName =
                                    helpers_1.Helper.getNestedValue((_a = state.dynamic) === null || _a === void 0 ? void 0 : _a[rootState || ''], elementProps.fileName.args.storedLocation || '') || 'document'; // Fallback if getNestedValue returns undefined
                            }
                            setFileName(tempFileName);
                            reactPrintFn();
                        }
                        else {
                            executeEventHandlers(elementProps.handlers, event);
                        }
                    } })));
            case 'capitalize':
                return (0, jsx_runtime_1.jsx)("div", { className: "capitalize", children: elementProps.label });
            case 'card': {
                var node = elementProps;
                return ((0, jsx_runtime_1.jsx)(ACCard_1.ACCard, __assign({}, node, { renderFields: function (fields) { return renderFields(fields, event); }, onClick: function () { return executeEventHandlers(elementProps.handlers, event); } })));
            }
            // case 'chip': {
            //   let className = '';
            //   let icon = null;
            //   let classNameByName: any;
            //   if (rootState === 'leads') {
            //     if (pageName === 'source') {
            //       classNameByName = [
            //         {
            //           label: 'Operator',
            //           className: 'bg-fuchsia-50 text-fuchsia-500',
            //           iconClassName: 'aci-operator-colored',
            //         },
            //         {
            //           label: 'Calls',
            //           className: 'bg-[#29AAE1]/5 text-[#29AAE1]',
            //           iconClassName: 'aci-call',
            //         },
            //         {
            //           label: 'Chatbot',
            //           className: 'bg-[#29AAE1]/5 text-[#29AAE1]',
            //           iconClassName: 'aci-chatbot-colored',
            //         },
            //         {
            //           label: 'Appointment',
            //           className: 'bg-[#F2F2F2]/50 text-default-300',
            //         },
            //         {
            //           label: 'Website',
            //           className: 'bg-[#F59F0D]/5 text-[#F59F0D]',
            //           iconClassName: 'aci-web-colored',
            //         },
            //       ];
            //     } else if (pageName === 'status') {
            //       classNameByName = [
            //         {
            //           label: 'New',
            //           className:
            //             'w-full p-1 px-2 rounded-md font-medium capitalize bg-[#29AAE1]/10 text-[#29AAE1]',
            //         },
            //         {
            //           label: 'Open',
            //           className:
            //             'w-full p-1 px-2 rounded-md font-medium capitalize bg-cyan-500/5 text-cyan-500',
            //         },
            //         {
            //           label: 'in-progress',
            //           className:
            //             'w-full p-1 px-2 rounded-md font-medium capitalize  bg-yellow-500/70 text-yellow-500',
            //         },
            //         {
            //           label: 'qualified',
            //           className:
            //             'w-full p-1 px-2 rounded-md font-medium capitalize  bg-fuchsia-500/70 text-fuchsia-500',
            //         },
            //         {
            //           label: 'closed',
            //           className:
            //             'w-full p-1 px-2 rounded-md font-medium capitalize  bg-red-500/70 text-red-500',
            //         },
            //         {
            //           label: 'Cold',
            //           className:
            //             'w-full p-1 px-2 rounded-md font-medium capitalize  bg-[#29AAE1]/10 text-[#29AAE1]',
            //         },
            //         {
            //           label: 'Warm',
            //           className:
            //             'w-full p-1 px-2 rounded-md font-medium capitalize  bg-yellow-500/10 text-yellow-500',
            //         },
            //       ];
            //     }
            //   }
            //   if (rootState == 'viewAppointment') {
            //     if (pageName === 'source') {
            //       className = `w-full p-1 px-2 rounded-md font-medium capitalize flex items-center gap-1 ${event.color}`;
            //       if (event?.iconClassName) {
            //         icon = (
            //           <i
            //             className={`aci ${event?.iconClassName} ac-dynamic-size size-4`}
            //           ></i>
            //         );
            //       }
            //     }
            //   }
            //   if (rootState == 'botactivity') {
            //     if (pageName === 'medium') {
            //       className = `w-full p-1 px-2 rounded-md font-medium capitalize flex items-center gap-1 ${event.color}`;
            //       if (event?.iconClassName) {
            //         icon = (
            //           <i
            //             className={`aci ${event?.iconClassName} ac-dynamic-size size-4`}
            //           ></i>
            //         );
            //       }
            //     }
            //   }
            //   if (rootState === 'messages') {
            //     className = `w-fit py-1 px-4 rounded-md font-medium flex ${event.color}`;
            //     if (event?.iconClassName) {
            //       icon = (
            //         <i
            //           className={`aci ${event?.iconClassName} ac-dynamic-size size-4`}
            //         ></i>
            //       );
            //     }
            //   }
            //   const classNames = elementProps.className || classNameByName;
            //   // check if the className prop is present and it is an array
            //   if (classNames && Array.isArray(classNames)) {
            //     classNames.map((eachClass: any) => {
            //       if (eachClass.label === elementProps.label) {
            //         className = `flex gap-1 items-center justify-center w-full p-1 px-2 rounded-md font-medium capitalize ${eachClass.className}`;
            //         if (eachClass?.iconClassName) {
            //           icon = (
            //             <i
            //               className={`aci ${eachClass?.iconClassName} ac-dynamic-size size-4`}
            //             ></i>
            //           );
            //         }
            //       }
            //     });
            //   } else if (
            //     elementProps.className &&
            //     typeof elementProps.className === 'string'
            //   ) {
            //     className = elementProps.className;
            //   }
            //   if (elementProps?.iconClassName) {
            //     icon = (
            //       <i
            //         className={`aci ${elementProps?.iconClassName} ac-dynamic-size size-4`}
            //       ></i>
            //     );
            //   }
            //   return (
            //     <span
            //       className={className}
            //       role="button"
            //       tabIndex={0}
            //       onClick={(e) => {
            //         e.stopPropagation();
            //         executeEventHandlers(elementProps.handlers || [], event);
            //       }}
            //       onKeyDown={(e) => {
            //         if (e.key === 'Enter' || e.key === ' ') {
            //           e.stopPropagation();
            //           executeEventHandlers(elementProps.handlers || [], event);
            //         }
            //       }}
            //     >
            //       <div>{icon}</div>
            //       <div>{elementProps.label}</div>
            //     </span>
            //   );
            // }
            case 'chart': {
                return ((0, jsx_runtime_1.jsx)(ACChart_1.ACChart, __assign({}, elementProps, { value: getValueFromRedux(), categories: getItemsFromRedux('categories') })));
            }
            case 'checkbox-group': {
                var node = elementProps;
                return ((0, jsx_runtime_1.jsx)(ACCheckboxGroup_1.ACCheckboxGroup, __assign({}, node, { value: getValueFromRedux(), onChange: function (value) {
                        return onHandleChange(elementProps.name || '', value, elementProps);
                    } })));
            }
            case 'chip': {
                var node = elementProps;
                var label = getLabelFromRedux();
                // console.log(860, label);
                return ((0, jsx_runtime_1.jsx)(ACChip_1.ACChip, { node: __assign(__assign({}, node), { label: label }), executeEventHandlers: executeEventHandlers }));
            }
            case 'chip-group': {
                var node = elementProps;
                var items = getItemsFromRedux() || [];
                return ((0, jsx_runtime_1.jsx)(ACChipGroup_1.ACChipGroup, { node: __assign(__assign({}, node), { items: items.map(function (item) { return (__assign(__assign({}, item), { name: item.value })); }) }), executeEventHandlers: executeEventHandlers }));
            }
            case 'circular-input': {
                var node = elementProps;
                var value = getValueFromRedux();
                return ((0, jsx_runtime_1.jsx)(ACCircularInput_1.ACCircularInput, __assign({}, node, { value: value, onChange: function (value) {
                        return onHandleChange(elementProps.name || '', value, elementProps);
                    } })));
            }
            case 'collection': {
                var node = elementProps;
                return ((0, jsx_runtime_1.jsx)(ACCollection_1.ACCollection, __assign({}, node, { data: getDataFromRedux(), renderFields: renderFields })));
            }
            case 'selectable-collection': {
                var node_2 = elementProps;
                return ((0, jsx_runtime_1.jsx)(ACSelectableCollection_1.ACSelectableCollection, __assign({}, node_2, { value: getValueFromRedux(), data: getDataFromRedux(), renderFields: renderFields, onSelect: function (item) { return onHandleChange(node_2.name || '', item, node_2); } })));
            }
            case 'nested-selectable-collection': {
                var node_3 = elementProps;
                return ((0, jsx_runtime_1.jsx)(ACNestedSelectableCollection_1.ACNestedSelectableCollection, __assign({}, node_3, { data: getDataFromRedux(), value: getValueFromRedux(), renderFields: renderFields, onSelect: function (item) { return onHandleChange(node_3.name || '', item, node_3); } })));
            }
            case 'counter':
                return ((0, jsx_runtime_1.jsx)(ACCounter_1.ACCounter, __assign({}, elementProps, { onChange: function (value) {
                        return onHandleChange(elementProps.name || '', value, elementProps);
                    } })));
            case 'datepicker':
                return ((0, jsx_runtime_1.jsx)(ACDatePicker_1.ACDatePickerElement, __assign({}, elementProps, { value: getValueFromRedux(), onChange: function (value) {
                        return onHandleChange(elementProps.name || '', value, elementProps);
                    } })));
            case 'daterange-picker': {
                var node = elementProps;
                return ((0, jsx_runtime_1.jsx)(ACDateRangeSegments_1.ACDateRangeSegments, __assign({}, node, { onChange: function (value) {
                        return onHandleChange(elementProps.name || '', value, elementProps);
                    }, value: getValueFromRedux(), segmentedOptions: elementProps.segmentedOptions || [
                        { tooltip: 'One Day', label: '1D', value: 'TD' },
                        { tooltip: 'One Week', label: '1W', value: 'TW' },
                        { tooltip: 'One Month', label: '1M', value: 'TM' },
                    ] })));
            }
            case 'div': {
                return (0, jsx_runtime_1.jsx)(ACDivContainer_1.ACDivContainer, __assign({}, elementProps));
            }
            case 'date-time-display': {
                var node = elementProps;
                return (0, jsx_runtime_1.jsx)(ACDateTimeDisplay_1.ACDateTimeDisplay, __assign({}, node, { label: getLabelFromRedux() }));
            }
            case 'empty': {
                var node = elementProps;
                return (0, jsx_runtime_1.jsx)(ACEmpty_1.ACEmpty, __assign({}, node));
            }
            case 'fixed-row-input-table': {
                return ((0, jsx_runtime_1.jsx)(ACFixedRowInputTable_1.ACFixedRowInputTable, __assign({}, elementProps, { onChange: function (value) {
                        return onHandleChange(elementProps.name || '', value, elementProps);
                    }, rootState: rootState, context: context })));
            }
            case 'file-upload': {
                var node_4 = elementProps;
                return ((0, jsx_runtime_1.jsx)(ACFileUpload_1.ACFileUpload, __assign({}, node_4, { onFileUpload: function (data, headers, fileName) {
                        // Process the uploaded file data
                        var fileData = {
                            data: data,
                            headers: headers,
                            fileName: fileName,
                        };
                        // Call onChange handlers with processed data
                        onHandleChange(node_4.name || '', fileData, node_4);
                    }, onFileRemove: function () {
                        // Call onChange handlers to clear data
                        onHandleChange(node_4.name || '', null, node_4);
                    } })));
            }
            case 'file-gallery': {
                var node = elementProps;
                var files = getItemsFromRedux('files') || [];
                return ((0, jsx_runtime_1.jsx)(ACFileGallery_1.ACFileGallery, { files: files, openInNewTab: node.openInNewTab !== false, containerClassName: node.containerClassName, itemClassName: node.itemClassName, imageClassName: node.imageClassName, showFileName: node.showFileName !== false, showDate: node.showDate !== false, emptyMessage: node.emptyMessage }));
            }
            case 'format-date':
                return ((0, jsx_runtime_1.jsx)("div", { children: (0, moment_1.default)(elementProps.label).format(elementProps.dateFormat || 'DD-MM-YYYY HH:mm') }));
            case 'gradient-card-group': {
                var node = elementProps;
                return (0, jsx_runtime_1.jsx)(ACGradientCardGroup_1.ACGradientCardGroup, __assign({}, node, { context: context }));
            }
            case 'html-content':
                return ((0, jsx_runtime_1.jsx)("div", { className: "html-content ".concat(elementProps.className), dangerouslySetInnerHTML: {
                        __html: getLabelFromRedux(),
                    } }));
            case 'href':
                return event.type === 'pdf' ? ((0, jsx_runtime_1.jsx)("a", { target: (elementProps.target && elementProps.target) || '_blank', className: elementProps.className || 'underline text-blue-500', onClick: function (e) {
                        e.stopPropagation();
                        executeEventHandlers(elementProps.handlers || [], event);
                    }, href: process.env.REACT_APP_BASE_URL +
                        '/api/' +
                        ((_s = event.bottraining_docs[0]) === null || _s === void 0 ? void 0 : _s.path) +
                        ((_t = event.bottraining_docs[0]) === null || _t === void 0 ? void 0 : _t.file_name), children: ((_u = event.bottraining_docs[0]) === null || _u === void 0 ? void 0 : _u.original_name) + ' ' }, ((_v = event.bottraining_docs[0]) === null || _v === void 0 ? void 0 : _v.path) +
                    ((_w = event.bottraining_docs[0]) === null || _w === void 0 ? void 0 : _w.file_name))) : ((0, jsx_runtime_1.jsx)("span", {}));
            case 'image':
                return (elementProps === null || elementProps === void 0 ? void 0 : elementProps.iconClassName) ? ((0, jsx_runtime_1.jsx)("div", { className: elementProps.containerClassName || '', children: (0, jsx_runtime_1.jsx)("i", { className: elementProps === null || elementProps === void 0 ? void 0 : elementProps.iconClassName, onClick: function (e) {
                            elementProps.stopPropagation && e.stopPropagation();
                            props.selectedRecord && props.selectedRecord(elementProps);
                            elementProps.handlers &&
                                executeEventHandlers(elementProps.handlers, event);
                        } }) })) : ((0, jsx_runtime_1.jsx)(ACImage_1.ACImage, __assign({}, elementProps, { img: getItemsFromRedux('img'), onClick: function () {
                        props.selectedRecord && props.selectedRecord(elementProps);
                        elementProps.handlers &&
                            executeEventHandlers(elementProps.handlers, event);
                    } })));
            case 'icon': {
                var node = elementProps;
                return (0, jsx_runtime_1.jsx)(ACIcon_1.ACIcon, __assign({}, node));
            }
            case 'input-number':
                return ((0, jsx_runtime_1.jsx)(ACInputNumber_1.ACInputNumber, __assign({}, elementProps, { value: typeof elementProps.valueSource === 'object'
                        ? helpers_1.Helper.getNestedValue((_y = (_x = context === null || context === void 0 ? void 0 : context.state) === null || _x === void 0 ? void 0 : _x.dynamic) === null || _y === void 0 ? void 0 : _y[rootState || ''], elementProps.valueSource.storedLocation)
                        : ((_3 = (_2 = (_1 = (_0 = (_z = context === null || context === void 0 ? void 0 : context.state) === null || _z === void 0 ? void 0 : _z.dynamic) === null || _0 === void 0 ? void 0 : _0[rootState || '']) === null || _1 === void 0 ? void 0 : _1[elementProps.name]) !== null && _2 !== void 0 ? _2 : elementProps.value) !== null && _3 !== void 0 ? _3 : ''), onChange: function (value) {
                        return onHandleChange(elementProps.name || '', value, elementProps);
                    } })));
            case 'input-text': {
                var node_5 = elementProps;
                var value = getValueFromRedux();
                // console.log('__value event input-text', value);
                return ((0, jsx_runtime_1.jsx)(ACInputText_1.ACInputText, __assign({}, node_5, { isSearch: node_5.isSearch ? node_5.isSearch : true, value: value, onChange: function (value) {
                        return onHandleChange(node_5.name || '', value, node_5);
                    }, icon: node_5.icon ? node_5.icon : 'search' })));
            }
            case 'modal':
                return ((0, jsx_runtime_1.jsx)(antd_1.Modal, { visible: ((_7 = (_6 = (_5 = (_4 = context === null || context === void 0 ? void 0 : context.state) === null || _4 === void 0 ? void 0 : _4.dynamic) === null || _5 === void 0 ? void 0 : _5[rootState || '']) === null || _6 === void 0 ? void 0 : _6[elementProps.name]) === null || _7 === void 0 ? void 0 : _7['visible']) || false, okButtonProps: { style: { display: 'none' } }, cancelButtonProps: { style: { display: 'none' } }, closable: false, className: elementProps.containerClassName, width: elementProps.width, footer: null, centered: true, mask: (_8 = elementProps.mask) !== null && _8 !== void 0 ? _8 : true, styles: {
                        mask: elementProps.mask === false ? { display: 'none' } : {},
                    }, style: elementProps.mask === false
                        ? {
                            position: 'absolute',
                            pointerEvents: 'none',
                        }
                        : {}, modalRender: function (modal) {
                        // Only wrap in Draggable if draggable prop is true
                        if (elementProps === null || elementProps === void 0 ? void 0 : elementProps.draggable) {
                            var _a = (0, react_2.useState)(true), disabled = _a[0], setDisabled_1 = _a[1];
                            var _b = (0, react_2.useState)({
                                left: 0,
                                top: 0,
                                bottom: 0,
                                right: 0,
                            }), bounds = _b[0], setBounds_1 = _b[1];
                            var draggleRef_1 = (0, react_2.useRef)(null);
                            var onStart_1 = function (_event, uiData) {
                                var _a;
                                var _b = window.document.documentElement, clientWidth = _b.clientWidth, clientHeight = _b.clientHeight;
                                var targetRect = (_a = draggleRef_1.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
                                if (!targetRect) {
                                    return;
                                }
                                setBounds_1({
                                    left: -targetRect.left + uiData.x,
                                    right: clientWidth - (targetRect.right - uiData.x),
                                    top: -targetRect.top + uiData.y,
                                    bottom: clientHeight - (targetRect.bottom - uiData.y),
                                });
                            };
                            return ((0, jsx_runtime_1.jsx)(react_draggable_1.default, { disabled: disabled, bounds: bounds, nodeRef: draggleRef_1, onStart: function (event, uiData) { return onStart_1(event, uiData); }, children: (0, jsx_runtime_1.jsx)("div", { ref: draggleRef_1, style: {
                                        cursor: elementProps.draggable ? 'move' : 'default',
                                    }, onMouseOver: function () {
                                        return elementProps.draggable && setDisabled_1(false);
                                    }, onMouseOut: function () {
                                        return elementProps.draggable && setDisabled_1(true);
                                    }, onFocus: function () {
                                        return elementProps.draggable && setDisabled_1(false);
                                    }, onBlur: function () { return elementProps.draggable && setDisabled_1(true); }, role: "button", tabIndex: 0, children: modal }) }));
                        }
                        // If not draggable, return modal as-is
                        return modal;
                    }, children: (0, jsx_runtime_1.jsx)("div", { className: elementProps === null || elementProps === void 0 ? void 0 : elementProps.className, children: renderFields((elementProps === null || elementProps === void 0 ? void 0 : elementProps.fields) || []) }) }));
            case 'notifications': {
                var node_6 = elementProps;
                return ((0, jsx_runtime_1.jsx)(ACNotifications_1.ACNotifications, __assign({}, node_6, { items: getItemsFromRedux('items'), renderFields: renderFields, onNoticationClick: function (e) {
                        return executeEventHandlers((node_6 === null || node_6 === void 0 ? void 0 : node_6.handlers) || [], e);
                    } })));
            }
            case 'otp':
                return ((0, jsx_runtime_1.jsx)(ACOtpElement_1.ACOtpElement, __assign({}, elementProps, { onChange: function (value) {
                        return onHandleChange(elementProps.name || '', value, elementProps);
                    } })));
            case 'pagination': {
                var node_7 = elementProps;
                return ((0, jsx_runtime_1.jsx)(ACPagination_1.ACPagination, __assign({}, node_7, { value: getValueFromRedux() || {}, onChange: function (value) {
                        return onHandleChange(node_7.name || '', value, node_7);
                    } })));
            }
            case 'phone-masker':
                return ((0, jsx_runtime_1.jsx)(ACPhoneMasker_1.ACPhoneMasker, __assign({}, elementProps, { phoneNumber: getValueFromRedux(), className: elementProps.className })));
            case 'popconfirm':
                return ((0, jsx_runtime_1.jsx)("div", { onClick: function (e) { return e.stopPropagation(); }, children: (0, jsx_runtime_1.jsx)(antd_1.Popconfirm, { title: elementProps.title, onConfirm: function (e) {
                            executeEventHandlers(elementProps.onSuccess || {}, event);
                        }, okText: elementProps.okText || 'Yes', cancelText: elementProps.cancelText || 'No', children: elementProps.label &&
                            typeof elementProps.label === 'object' &&
                            elementProps.label.element ? (
                        // Use renderElement to render any component specified in the schema
                        renderElement(elementProps.label, event)) : elementProps.label && elementProps.label.type === 'icon' ? (
                        // Maintain backward compatibility with the existing icon rendering
                        (0, jsx_runtime_1.jsx)("img", { src: elementProps.label.url, alt: elementProps.label.alt })) : (
                        // Default case for simple text labels
                        elementProps.label) }) }));
            case 'popover-dynamic':
                return ((0, jsx_runtime_1.jsx)(antd_1.Popover, { overlayStyle: elementProps.overlayStyle, content: elementProps.dataSource
                        ? event[elementProps.dataSource]
                        : elementProps.label === '--'
                            ? 'No Comments'
                            : elementProps.label, children: renderFields([__assign(__assign({}, elementProps.child_element), { label: elementProps.label })], event, pageName) }));
            case 'print_container':
                return (0, jsx_runtime_1.jsx)(ACPrint_1.ACPrint, __assign({}, elementProps, { renderFields: renderFields }));
            case 'profile-menu': {
                var node = elementProps;
                return ((0, jsx_runtime_1.jsx)(ACProfileMenu_1.ACProfileMenu, __assign({}, node, { avatarText: getAvatarTextFromRedux() || '', executeEventHandlers: executeEventHandlers })));
            }
            case 'progress': {
                var node = elementProps;
                return (0, jsx_runtime_1.jsx)(ACProgress_1.ACProgress, __assign({}, node, { value: getValueFromRedux() }));
            }
            case 'progress-group': {
                var node = elementProps;
                return (0, jsx_runtime_1.jsx)(ACProgressGroup_1.ACProgressGroup, __assign({}, node, { options: getOptionsFromRedux() }));
            }
            case 'qr-code':
                // Get the base value from props
                // Process each parameter and replace in the value string
                return (0, jsx_runtime_1.jsx)(ACQRComponent_1.ACQRComponent, __assign({}, elementProps, { rootState: rootState }));
            case 'radio': {
                var node_8 = elementProps;
                return ((0, jsx_runtime_1.jsx)(ACRadioGroup_1.ACRadioGroup, __assign({}, node_8, { options: getOptionsFromRedux(), value: getValueFromRedux(), onChange: function (value) {
                        return onHandleChange(node_8.name || '', value, node_8);
                    } })));
            }
            case 'rupee': {
                var node = elementProps;
                var label = utils_1.Utils.formatCurrency(getLabelFromRedux());
                return (0, jsx_runtime_1.jsx)(ACTypography_1.ACTypography, __assign({}, node, { label: label }));
            }
            case 'segmented':
                // if (elementProps.segmentedOptionsSource) {
                //   elementProps.segmentedOptions = Helper.getNestedValue(
                //     state?.dynamic?.[rootState || ''],
                //     elementProps.segmentedOptionsSource.storedLocation,
                //   );
                // }
                // if (elementProps.valueSource) {
                //   elementProps.value = getNestedValue(
                //     state?.dynamic?.[rootState || ''],
                //     elementProps.valueSource.storedLocation,
                //   );
                // }
                return ((0, jsx_runtime_1.jsx)(ACSegmentedElement_1.ACSegmentedElement, __assign({}, elementProps, { options: (typeof elementProps.optionsSource === 'object' &&
                        helpers_1.Helper.getNestedValue((_10 = (_9 = context === null || context === void 0 ? void 0 : context.state) === null || _9 === void 0 ? void 0 : _9.dynamic) === null || _10 === void 0 ? void 0 : _10[rootState || ''], elementProps.optionsSource.storedLocation)) ||
                        [], onChange: function (value) {
                        return onHandleChange(elementProps.name || '', value, elementProps);
                    } })));
            // case 'single-select':
            //   if (typeof elementProps.optionsSource === 'object') {
            //     // console.log('__redux', elementProps);
            //     elementProps.options =
            //       getNestedValue(
            //         state?.dynamic?.[rootState || ''],
            //         elementProps.optionsSource.storedLocation,
            //       ) || [];
            //   }
            case 'single-select': {
                var options = getOptionsFromRedux();
                return ((0, jsx_runtime_1.jsx)(ACSelectElement_1.ACSelectElement, __assign({}, elementProps, { value: getValueFromRedux(), options: options, onChange: function (value) {
                        // executeEventHandlers(elementProps.handlers, event, value)
                        return onHandleChange(elementProps.name || '', value, elementProps);
                    }, rootState: rootState })));
            }
            case 'skeleton': {
                var node = elementProps;
                return (0, jsx_runtime_1.jsx)(ACSkeleton_1.ACSkeleton, __assign({}, node));
            }
            case 'skeleton-group': {
                var node = elementProps;
                return (0, jsx_runtime_1.jsx)(ACSkeletonGroup_1.ACSkeletonGroup, __assign({}, node));
            }
            case 'slicedString':
                var string = elementProps.label;
                var length_1 = elementProps.length;
                var minIndex = elementProps.minIndex;
                var maxIndex = elementProps.maxIndex;
                return ((0, jsx_runtime_1.jsx)("div", { children: string.length > length_1
                        ? "".concat(string.slice(minIndex, maxIndex), "...")
                        : string || '--' }));
            case 'span': {
                var node = elementProps;
                var label = getLabelFromRedux();
                if (node === null || node === void 0 ? void 0 : node.prefix) {
                    label = utils_1.Utils.setPrefix({ text: label, prefix: node === null || node === void 0 ? void 0 : node.prefix });
                }
                if (node === null || node === void 0 ? void 0 : node.suffix) {
                    label = utils_1.Utils.setSuffix({ text: label, suffix: node === null || node === void 0 ? void 0 : node.suffix });
                }
                return ((0, jsx_runtime_1.jsx)("span", { className: elementProps.className, onClick: function (e) {
                        if (Array.isArray(elementProps.handlers) &&
                            elementProps.handlers.length > 0) {
                            e.stopPropagation();
                            executeEventHandlers(elementProps.handlers || [], event);
                        }
                    }, children: label }));
            }
            case 'table': {
                // if (elementProps.loadingSource) {
                //   const args = {
                //     obj: context?.state?.dynamic?.[rootState || ''],
                //     path: `${elementProps.name}.loading`,
                //   };
                //   ACBillingTableComponent;
                //   elementProps.loading = Helper.getNestedValue(args.obj, args.path);
                // }
                // console.log('calling table element', elementProps);
                // console.log(
                //   '__tbody',
                //   context?.state?.dynamic?.[rootState || '']?.[
                //     elementProps.name || ''
                //   ]?.['data'],
                // );
                var isLoading = ((_13 = (_12 = (_11 = context === null || context === void 0 ? void 0 : context.state) === null || _11 === void 0 ? void 0 : _11.dynamic) === null || _12 === void 0 ? void 0 : _12[rootState || '']) === null || _13 === void 0 ? void 0 : _13["".concat(elementProps.name, "Loading")]) || false;
                return ((0, jsx_runtime_1.jsx)(ACTableElement_1.ACTableElement, __assign({}, elementProps, { tbody: 
                    // typeof elementProps.tbody === 'object' &&
                    // elementProps.tbody?.storedLocation
                    //   ? Helper.getNestedValue(
                    //       context?.state?.dynamic?.[rootState || ''],
                    //       elementProps.tbody.storedLocation,
                    //     )
                    //   : context?.state?.dynamic?.[rootState || '']?.[
                    //       elementProps.name || ''
                    //     ]?.['response']?.['data'] || []
                    helpers_1.Helper.getNestedValue((_15 = (_14 = context === null || context === void 0 ? void 0 : context.state) === null || _14 === void 0 ? void 0 : _14.dynamic) === null || _15 === void 0 ? void 0 : _15[rootState || ''], elementProps.tbody.storedLocation), value: ((_19 = (_18 = (_17 = (_16 = context === null || context === void 0 ? void 0 : context.state) === null || _16 === void 0 ? void 0 : _16.dynamic) === null || _17 === void 0 ? void 0 : _17[rootState || '']) === null || _18 === void 0 ? void 0 : _18[elementProps.name]) === null || _19 === void 0 ? void 0 : _19['pagination']) ||
                        ((_22 = (_21 = (_20 = context === null || context === void 0 ? void 0 : context.state) === null || _20 === void 0 ? void 0 : _20.dynamic) === null || _21 === void 0 ? void 0 : _21[rootState || '']) === null || _22 === void 0 ? void 0 : _22['pagination']) || {
                        name: 'pagination',
                        page: 1,
                        pageSize: 20,
                    }, count: ((_27 = (_26 = (_25 = (_24 = (_23 = context === null || context === void 0 ? void 0 : context.state) === null || _23 === void 0 ? void 0 : _23.dynamic) === null || _24 === void 0 ? void 0 : _24[rootState || '']) === null || _25 === void 0 ? void 0 : _25[elementProps.name || '']) === null || _26 === void 0 ? void 0 : _26['response']) === null || _27 === void 0 ? void 0 : _27['total']) || 0, onChange: function (value) {
                        return onHandleChange((elementProps === null || elementProps === void 0 ? void 0 : elementProps.name) || '', value, elementProps);
                    }, loading: isLoading, renderElement: renderElement, renderFields: renderFields, className: elementProps === null || elementProps === void 0 ? void 0 : elementProps.className, variant: (elementProps === null || elementProps === void 0 ? void 0 : elementProps.variant) || 'plain', size: (elementProps === null || elementProps === void 0 ? void 0 : elementProps.size) || 'small', indexWidth: (elementProps === null || elementProps === void 0 ? void 0 : elementProps.indexWidth) || 30, 
                    // rowClick={elementProps?.rowClick || true}
                    pagination: (elementProps === null || elementProps === void 0 ? void 0 : elementProps.pagination) || true, tableHeight: elementProps === null || elementProps === void 0 ? void 0 : elementProps.tableHeight, context: context })));
            }
            case 'tabs': {
                var isInline = (elementProps === null || elementProps === void 0 ? void 0 : elementProps.variant) === 'inline';
                var node = isInline
                    ? elementProps
                    : elementProps;
                var options = getOptionsFromRedux();
                return ((0, jsx_runtime_1.jsx)(ACTabsControlled_1.ACTabsControlled, __assign({}, node, { options: options, value: getValueFromRedux(), onChange: function (value) {
                        return onHandleChange(elementProps.name || '', value, elementProps);
                    }, context: context })));
            }
            // case 'toggle': {
            //   return (
            //     <div
            //       className="flex justify-center items-center"
            //       role="presentation"
            //       onClick={(e) => e?.stopPropagation()}
            //       onKeyDown={(e) => {
            //         if (e.key === 'Enter' || e.key === ' ') {
            //           e.stopPropagation();
            //         }
            //       }}
            //       tabIndex={0}
            //     >
            //       <Switch
            //         defaultChecked={true}
            //         size="small"
            //         onClick={(e: any) =>
            //           executeEventHandlers(
            //             elementProps.handlers || {},
            //             event,
            //             rootState,
            //             // context,
            //           )
            //         }
            //       />
            //     </div>
            //   );
            // }
            case 'textarea': {
                var node_9 = elementProps;
                return ((0, jsx_runtime_1.jsx)(ACTextarea_1.ACTextarea, __assign({}, node_9, { value: getValueFromRedux(), onChange: function (value) { return onHandleChange(node_9.name || '', value, node_9); } })));
            }
            case 'text-editor': {
                var node_10 = elementProps;
                return ((0, jsx_runtime_1.jsx)(ACTextEditor_1.ACTextEditor, __assign({}, node_10, { value: getValueFromRedux(), onChange: function (value) { return onHandleChange(node_10.name || '', value, node_10); } })));
            }
            case 'timeline': {
                var node = elementProps;
                return ((0, jsx_runtime_1.jsx)(ACTimeline_1.ACTimeline, __assign({}, node, { data: getDataFromRedux(), renderFields: renderFields })));
            }
            case 'toggle': {
                return ((0, jsx_runtime_1.jsx)("div", { className: "flex justify-center items-center", role: "presentation", onClick: function (e) { return e === null || e === void 0 ? void 0 : e.stopPropagation(); }, onKeyDown: function (e) {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.stopPropagation();
                        }
                    }, tabIndex: 0, children: (0, jsx_runtime_1.jsx)(antd_1.Switch, { checked: event === null || event === void 0 ? void 0 : event.is_active, onChange: function (newChecked) {
                            // Create a copy of the event with the proposed new value
                            // but don't update the UI until API call succeeds
                            var eventWithNewValue = __assign(__assign({}, event), { is_active: newChecked });
                            executeEventHandlers(elementProps.handlers || [], eventWithNewValue, newChecked);
                        }, size: "small" }) }));
            }
            case 'tooltip-dynamic':
                var baseTitle = elementProps.title;
                var tooltipTitle = baseTitle;
                // Process string interpolation here in the tooltip component
                if (typeof baseTitle === 'string' && baseTitle.includes('${')) {
                    // Handle string interpolation
                    tooltipTitle = baseTitle.replace(/\${([^}]+)}/g, function (match, key) {
                        // Get value from event (which should be the record data)
                        var value = event === null || event === void 0 ? void 0 : event[key];
                        // Ensure the value is a string or number to prevent React errors
                        if (value === null || value === undefined) {
                            return match;
                        }
                        else if (typeof value === 'object') {
                            return JSON.stringify(value);
                        }
                        else {
                            return String(value);
                        }
                    });
                }
                else if (typeof baseTitle === 'object' && (baseTitle === null || baseTitle === void 0 ? void 0 : baseTitle.message)) {
                    // We may still get an object if it wasn't fully processed in TableElement
                    tooltipTitle = baseTitle.message.replace(/\${([^}]+)}/g, function (match, key) {
                        var value = event === null || event === void 0 ? void 0 : event[key];
                        if (value === null || value === undefined) {
                            return match;
                        }
                        else if (typeof value === 'object') {
                            return JSON.stringify(value);
                        }
                        else {
                            return String(value);
                        }
                    });
                }
                return ((0, jsx_runtime_1.jsx)(tooltip_1.default, { title: tooltipTitle, children: renderFields(elementProps.childElements, event) }));
            case 'typography': {
                var node = elementProps;
                var label = getLabelFromRedux({ transformer: node === null || node === void 0 ? void 0 : node.transformer });
                if (node === null || node === void 0 ? void 0 : node.prefix) {
                    label = utils_1.Utils.setPrefix({ text: label, prefix: node === null || node === void 0 ? void 0 : node.prefix });
                }
                if (node === null || node === void 0 ? void 0 : node.suffix) {
                    label = utils_1.Utils.setSuffix({ text: label, suffix: node === null || node === void 0 ? void 0 : node.suffix });
                }
                return (0, jsx_runtime_1.jsx)(ACTypography_1.ACTypography, __assign({}, node, { label: label }));
            }
            case 'doc-link': {
                var node_11 = elementProps;
                var links = getItemsFromRedux('links') || [];
                return ((0, jsx_runtime_1.jsx)(ACLink_1.default, { links: links, target: node_11.target || '_blank', containerClassName: node_11.containerClassName, linkClassName: node_11.linkClassName, iconContainerClassName: node_11.iconContainerClassName, iconClassName: node_11.iconClassName, labelClassName: node_11.labelClassName, emptyMessage: node_11.emptyMessage, showIcon: node_11.showIcon !== false, icon: node_11.icon, emptyIcon: node_11.emptyIcon, layout: node_11.layout || 'grid', delete: node_11.delete || false, deleteIconClassName: node_11.deleteIconClassName, onDelete: node_11.onDelete
                        ? function (link, index) {
                            executeEventHandlers(node_11.onDelete, link, link);
                        }
                        : undefined }));
            }
            default:
                return null;
        }
    };
    var renderFields = function (schema, event, pageName) {
        return (schema &&
            schema.map(function (eachSection, index) {
                var _a, _b, _c, _d;
                var visibleByCond = (eachSection === null || eachSection === void 0 ? void 0 : eachSection.visibleCondition)
                    ? globalHandlers_1.default.execFunction({ condition: eachSection === null || eachSection === void 0 ? void 0 : eachSection.visibleCondition, event: event }, context)
                    : true;
                var visibleByVal = ((_a = eachSection === null || eachSection === void 0 ? void 0 : eachSection.visible) === null || _a === void 0 ? void 0 : _a.storedLocation)
                    ? helpers_1.Helper.getNestedValue((_c = (_b = context === null || context === void 0 ? void 0 : context.state) === null || _b === void 0 ? void 0 : _b.dynamic) === null || _c === void 0 ? void 0 : _c[rootState || ''], eachSection.visible.storedLocation) !== false
                    : true;
                if ((eachSection === null || eachSection === void 0 ? void 0 : eachSection.visible) !== false && visibleByCond && visibleByVal) {
                    if (eachSection === null || eachSection === void 0 ? void 0 : eachSection.showSkeleton) {
                        return ((0, jsx_runtime_1.jsx)(react_2.default.Fragment, { children: eachSection.loader }, index));
                    }
                    // const visible =
                    //   eachSection?.visible === false
                    //     ? false
                    //     : Utils.evaluateConditionTree({
                    //         node: eachSection?.visibleConditions || {},
                    //         store: context.state?.dynamic?.[rootState || ''],
                    //       });
                    return ((0, jsx_runtime_1.jsx)(react_2.default.Fragment, { children: !['modal'].includes((eachSection === null || eachSection === void 0 ? void 0 : eachSection.element) || '') &&
                            !['print', 'card'].includes((eachSection === null || eachSection === void 0 ? void 0 : eachSection.element) || '') &&
                            !['print_container'].includes((eachSection === null || eachSection === void 0 ? void 0 : eachSection.element) || '') &&
                            (eachSection === null || eachSection === void 0 ? void 0 : eachSection.fields) &&
                            ((_d = eachSection === null || eachSection === void 0 ? void 0 : eachSection.fields) === null || _d === void 0 ? void 0 : _d.length) > 0 ? ((0, jsx_runtime_1.jsxs)(react_2.default.Fragment, { children: [(eachSection === null || eachSection === void 0 ? void 0 : eachSection.showSkeleton)
                                    ? eachSection === null || eachSection === void 0 ? void 0 : eachSection.loader
                                    : renderElement(eachSection, event, pageName), (0, jsx_runtime_1.jsx)("div", { className: (eachSection === null || eachSection === void 0 ? void 0 : eachSection.showSkeleton) ? '' : eachSection === null || eachSection === void 0 ? void 0 : eachSection.className, ref: eachSection.divRef, children: renderFields(eachSection === null || eachSection === void 0 ? void 0 : eachSection.fields, event, pageName) }, index), (eachSection === null || eachSection === void 0 ? void 0 : eachSection.dateTime) ? ((0, jsx_runtime_1.jsx)("p", { style: {
                                        fontSize: '10px',
                                        textAlign: eachSection.source === 'bot' ? 'left' : 'right',
                                    }, children: (0, moment_1.default)(eachSection.dateTime).format('LT') })) : ('')] })) : ((0, jsx_runtime_1.jsxs)(react_2.default.Fragment, { children: [renderElement(eachSection, event, pageName), eachSection.dateTime ? ((0, jsx_runtime_1.jsx)("p", { style: {
                                        fontSize: '10px',
                                        textAlign: eachSection.source === 'bot' ? 'left' : 'right',
                                    }, children: (0, moment_1.default)(eachSection.dateTime).format('LT') })) : ('')] })) }, index));
                }
                return null;
            }));
    };
    return ((0, jsx_runtime_1.jsxs)(antd_1.ConfigProvider, { theme: {
            components: {
                Segmented: {
                    itemSelectedBg: '#f1f2ff',
                    itemSelectedColor: '#3341bb',
                },
            },
            token: {
                colorPrimary: '#1E30D8',
                colorBgContainer: '#FFFFFF',
            },
        }, children: [(0, jsx_runtime_1.jsx)(LoadingState_1.default, { isLoading: (_q = (_p = (_o = context === null || context === void 0 ? void 0 : context.state) === null || _o === void 0 ? void 0 : _o.dynamic) === null || _p === void 0 ? void 0 : _p[rootState || '']) === null || _q === void 0 ? void 0 : _q.loading }), (0, jsx_runtime_1.jsx)("div", { className: (_r = props === null || props === void 0 ? void 0 : props.json) === null || _r === void 0 ? void 0 : _r.className, "data-scroll-target": "ui-builder-parent", children: renderFields(schema) })] }));
};
var UIBuilder = function (props) {
    var _a, _b, _c, _d;
    var json = (0, restructureSchema_1.processSchemaCollection)(props === null || props === void 0 ? void 0 : props.json);
    return ((0, jsx_runtime_1.jsxs)(RefProvider_1.RefProvider, { children: [(0, jsx_runtime_1.jsx)(react_toastify_1.ToastContainer, {}), (0, react_1.createElement)(UIBuilderChild, __assign({}, props, { json: json, key: (_b = (_a = json === null || json === void 0 ? void 0 : json.schema) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.name }))] }, (_d = (_c = json === null || json === void 0 ? void 0 : json.schema) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.name));
};
exports.UIBuilder = UIBuilder;
